import { GQL } from "../index";
// Rule: soll - haben
export class SollHaben {
    static isRecordKontoHaben(recordBrutto, product) {
        const bruttoPositive = recordBrutto >= 0;
        return this.isRecordPositiveBruttoHaben(product) ? bruttoPositive : !bruttoPositive;
    }
    static isItemKontoHaben(recordBrutto, itemBrutto, productKey) {
        const recordIsPositive = recordBrutto > 0;
        const recordIsHaben = this.isRecordKontoHaben(recordBrutto, productKey);
        let itemIsHaben = recordIsHaben;
        // if item has same sign as record brutto, than if record is Soll, item will be Haben
        if (itemBrutto > 0 === recordIsPositive) {
            itemIsHaben = !itemIsHaben;
        }
        return itemIsHaben;
    }
    static areSameSign(product1, product2) {
        return this.isRecordPositiveBruttoHaben(product1) === this.isRecordPositiveBruttoHaben(product2);
    }
    static isRecordPositiveBruttoHaben(product) {
        switch (product) {
            case GQL.IProductKey.Er:
            case GQL.IProductKey.ErA:
                return true;
            case GQL.IProductKey.Deb:
            case GQL.IProductKey.Kb:
            case GQL.IProductKey.Bank:
            case GQL.IProductKey.La:
            case GQL.IProductKey.Fe:
            case GQL.IProductKey.Pos:
                return false;
            default:
                throw new Error("unknown product: " + product);
        }
    }
}
//# sourceMappingURL=SollHaben.js.map